export default "data:text/javascript;base64,aW1wb3J0IE1hcE1haW4gZnJvbSAnLi9NYXBNYWluLnZ1ZScKZXhwb3J0IHsgTWFwTWFpbiB9Cg=="